// src/frontend_react/src/components/shared/PromptModal.js
import React, { useState, useEffect } from 'react';
import Modal from '../ui/Modal/Modal';
import Input from '../ui/Input/Input';
import Button from '../ui/Button/Button';
import Stack, { HStack } from '../ui/Stack/Stack';
import Typography from '../ui/Typography/Typography';

const PromptModal = ({
  isOpen,
  onClose,
  onSubmit,
  title,
  message,
  inputLabel,
  inputPlaceholder,
  initialValue = '',
  submitText = 'Submit',
  cancelText = 'Cancel',
  isSubmitting = false,
}) => {
  const [inputValue, setInputValue] = useState(initialValue);

  useEffect(() => {
    if (isOpen) {
      setInputValue(initialValue);
    }
  }, [isOpen, initialValue]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(inputValue);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <HStack spacing="sm" justifyContent="flex-end">
          <Button variant="outline" onClick={onClose} disabled={isSubmitting}>
            {cancelText}
          </Button>
          <Button onClick={handleSubmit} isLoading={isSubmitting} disabled={isSubmitting}>
            {submitText}
          </Button>
        </HStack>
      }
    >
      <form onSubmit={handleSubmit}>
        <Stack spacing="md">
          {message && <Typography>{message}</Typography>}
          <Input
            label={inputLabel}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder={inputPlaceholder}
            autoFocus
            disabled={isSubmitting}
          />
        </Stack>
      </form>
    </Modal>
  );
};

export default PromptModal;